if (!customElements.get('pp-brush-cart-sidebar')) {
  customElements.define('pp-brush-cart-sidebar', class PPBrushCartSidebar extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      document.addEventListener('cart:prepare-bundled-sections', this.prepareSection.bind(this), options);
      document.addEventListener('cart:change', this.updateFromCart.bind(this), options);
      document.addEventListener('cart:refresh', this.refresh.bind(this), options);
    }

    disconnectedCallback() { this.abortController?.abort(); }

    prepareSection(event) {
      const sectionId = this.dataset.sectionId;
      if (sectionId && !event.detail.sections.includes(sectionId)) event.detail.sections.push(sectionId);
    }

    updateFromCart(event) {
      const html = event.detail.cart?.sections?.[this.dataset.sectionId];
      if (!html || !this.replaceContent(html)) this.refresh();
    }

    async refresh() {
      const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(this.dataset.sectionId)}`);
      if (response.ok) this.replaceContent(await response.text());
    }

    replaceContent(html) {
      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsedDocument.querySelector('pp-brush-cart-sidebar');
      if (!replacement) return false;
      this.innerHTML = replacement.innerHTML;
      return true;
    }
  });
}
